import { Component, ElementRef, OnInit, viewChild } from '@angular/core';
import { StudyCreationComponent } from '../../components/usdm-components/study-creation/study-creation.component';
import { ExtractionMappingComponent } from '../../components/usdm-components/extraction-mapping/extraction-mapping.component';
import { UsdmValidationComponent } from '../../components/usdm-components/usdm-validation/usdm-validation.component';
import { Usdm2Service } from '../../services/ai/usdm2.service';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-usdm2',
  imports: [StudyCreationComponent, ExtractionMappingComponent, UsdmValidationComponent, StepperModule, ButtonModule],
  templateUrl: './usdm2.component.html',
  styleUrl: './usdm2.component.css'
})
export class Usdm2Component implements OnInit {
  currentStep: number = 1;
  completedSteps: Set<number> = new Set();
  scrollTop = viewChild<ElementRef>('scrollTop');
  sessionId: string | null = null;

  constructor(public usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.sessionId = crypto.randomUUID();
    this.usdm.setUsdmSessionId(this.sessionId);
    console.log('Session ID:', this.usdm.sessionId);
  }

  isStepCompleted(step: number): boolean {
    return this.completedSteps.has(step);
  }

  completeStep(step: number): void {
    this.completedSteps.add(step);
    if (step < 3) {
      this.currentStep = step + 1;
    }
    setTimeout(() => this.scrollToTop(), 0);
  }

  goBack(step: number): void {
    this.currentStep = step;
    setTimeout(() => this.scrollToTop(), 0);
  }

  scrollToTop() {
    const container = this.scrollTop();
    if (container && container.nativeElement) {
      container.nativeElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }  
  }
}
